import { render, staticRenderFns } from "./GracePeriods.vue?vue&type=template&id=686404e1&"
import script from "./GracePeriods.vue?vue&type=script&lang=js&"
export * from "./GracePeriods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./GracePeriods.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports